import usePrivateAxios from "@/common/api/usePrivateAxios"
import { RoleData, RoleResponse } from "@/common/types/roles"
import { useQuery } from "@tanstack/react-query"

interface UseRoleProps {
  id: string
}

const useRole = ({ id }: UseRoleProps) => {
  const privateAxios = usePrivateAxios()

  return useQuery<RoleResponse, unknown, RoleData>({
    queryKey: ['role', id],
    queryFn: () => {
      return privateAxios.get(`/roles/${id}`)
    },
    select: (data) => data?.data?.data
  })
}

export default useRole
